/*
 * @Author: bbqin
 * @Date: 2022-10-18 10:16:20
 * @LastEditTime: 2023-10-31 14:44:33
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\output.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import MetaFieldSetting from '.';
import { toast } from '@platform/api';
import { uuidv4 } from './setting/libs/utils';
import useMetaFieldSetting from './store';
import { getRawColumns, setColumns, resetColumns } from './setting/libs/request';

const uniqueId = uuidv4();

/**
 * @namespace MetaFieldSetting
 */

/**
 * 判断是否存在store
 * @ignore
 * @memberof MetaFieldSetting
 * @param {string} moduleId 
 * @returns {object|null}
 */
function getStore(moduleId) {
    if (this.metaFieldSettingDataSource && this.metaFieldSettingDataSource[moduleId]) {
        return this.metaFieldSettingDataSource[moduleId];
    } else {
        // console.warn('不存在metaFieldSettingDataSource');
        // return null
        // 暂时通过error 提醒业务组、 稳定后可去掉
        throw Error(`正在调用ID为${moduleId}的卡片容器的API, 但此卡片容器还未通过use.metaFieldSetting注册,请先注册此ID，才能正常调用API`);
    }
}

/**
 * 初始化模板
 * @ignore
 * @memberof MetaFieldSetting
 * @param {object} meta 
 */
function init(meta) {
    const { metaFieldSettingDataSource = {} } = this;
    const stores = Object.keys(metaFieldSettingDataSource);

    // 创建一个默认的
    if (stores.length === 0) {
        stores.push(uniqueId);
        this.metaFieldSettingDataSource = this.metaFieldSettingDataSource || {};
        this.metaFieldSettingDataSource[uniqueId] = metaFieldSettingDataSource[uniqueId] = useMetaFieldSetting();
    }

    stores.forEach(key => {
        metaFieldSettingDataSource[key].setMeta(meta);
    });
}

// 获取模板区域对应的store
function getMetaStore(pageScope, currentMeta, moduletype, moduleId) {
    let currentSource;
    switch (moduletype) {
        case 'form':
            // 需要注意下，表单分组，多页签等情况
            let DataSource = pageScope.formDataSource || {};
            // 用于更新meta
            let id = moduleId;
            // 当前store是否存在 是否为主表ID 
            if (DataSource[moduleId]) {
                currentSource = DataSource[moduleId];
            } else {
                // 不存在时 判断是否为子表ID, 找到子表ID对应的主表ID;
                let formrelation = (currentMeta && currentMeta.formrelation) || {};
                Object.keys(formrelation).forEach(item => {
                    if (Array.isArray(formrelation[item]) && formrelation[item].includes(moduleId) && DataSource[item]) {
                        currentSource = DataSource[item];
                        id = item;
                    } else {
                        // 暂时先移除 页签字段 todo
                        // 多页签数据处理 假如不是子表时  需进行判断是否为多页签子表 
                        let formassociatedrelation = (currentMeta && currentMeta.formassociatedrelation) || {};
                        Object.keys(formassociatedrelation).forEach(tabsID => {
                            if (Array.isArray(formassociatedrelation[tabsID].formtabs) && formassociatedrelation[tabsID].formtabs.includes(item)) {
                                currentSource = DataSource[tabsID];
                                id = tabsID;
                            }
                        });
                    }
                });
            }
            break;
        case 'table':
            {
                currentSource = pageScope.cardTableDataSource[moduleId] || pageScope.editTableDataSource[moduleId] || pageScope.tableDataSource[moduleId];
            }
            break;
        default:
            console.warn('未找到对应渲染的区域');
            break;
    }

    return currentSource;
}

function getMetaStoreItemVisible(currentSource, moduletype, attrcode) {
    let visible;
    switch (moduletype) {
        case 'form':
            visible = currentSource.getItemAttribute(attrcode, 'visible');
            break;
        case 'table':
            visible = currentSource.getColumnProps(attrcode, 'visible');
            break;
        default:
            console.warn('未找到对应渲染的区域');
            break;
    }

    return visible;
}

/**
 * 创建元数据字段设置组件
 * @memberof MetaFieldSetting
 * @param {MetaFieldSettingConfig} config 
 */
function createMetaFieldSetting(config = {}) {
    const id = config.id || uniqueId;

    let currentStore;
    // 页面对象
    const pageScope = this;

    if (!pageScope.metaFieldSettingDataSource || !pageScope.metaFieldSettingDataSource[id]) {
        currentStore = useMetaFieldSetting();
        pageScope.metaFieldSettingDataSource = pageScope.metaFieldSettingDataSource || {};
        pageScope.metaFieldSettingDataSource[id] = currentStore;
    } else {
        currentStore = getStore.call(this, id);
    }

    const { onSave, onReset, onHide } = config;

    return <MetaFieldSetting
        {...config}
        id={id}
        pageScope={pageScope}
        onSave={nextMeta => {
            const currentMeta = pageScope.meta.getMeta();
            nextMeta = nextMeta || {};
            // 保存请求的数据
            const data = {};
            Object.keys(nextMeta).forEach(areaCode => {
                const areaMeta = currentMeta[areaCode];
                if (areaMeta) {
                    const { moduletype, areaVisible } = areaMeta;
                    // 当前页面数据
                    const currentMetaItems = areaMeta.items;
                    // 设置数据
                    const nextMetaItems = nextMeta[areaCode]?.items;
                    // 设置显示态数据
                    const nextMetaItemsMap = nextMeta[areaCode]?.itemsMap || {};
                    // 原始数据里不展示的项
                    const rawHiddenItemOnj = nextMeta[areaCode]?.rawHiddenItemOnj || {};
                    // 未操作的用户级模板
                    const initUserMetaItemObj = nextMeta[areaCode]?.initUserMetaItemObj || {};
                    // store
                    const currentMetaStore = getMetaStore(pageScope, currentMeta, moduletype, areaCode);

                    if (currentMetaItems && nextMetaItems) {
                        // 领域添加的项
                        const customItems = [];

                        // 找到自定义数据
                        const currentMetaItemsMap = {};
                        currentMetaItems.forEach((item, index) => {
                            const { attrcode } = item;
                            currentMetaItemsMap[attrcode] = item;
                            if (!nextMetaItemsMap[attrcode]) {
                                customItems.push({
                                    attrcode,
                                    index,
                                    item,
                                });
                            }
                        });

                        // 保存用
                        const saveItems = [];

                        // 合并数据
                        const metaItems = nextMetaItems.map(item => {
                            const { attrcode } = item;
                            const { visible, islock, ishighlight, isbold, iscoredata } = nextMetaItemsMap[attrcode] || {};

                            const result = {};
                            visible !== undefined && (result.visible = visible);
                            islock !== undefined && (result.islock = islock);
                            islock !== undefined && (result.resizable = !islock);
                            // ishighlight !== undefined && (result.ishighlight = ishighlight);
                            isbold !== undefined && (result.isbold = isbold);
                            iscoredata !== undefined && (result.iscoredata = iscoredata);

                            // 用于保存
                            saveItems.push({ ...item, ...result });

                            // 解决业务设置了显隐性后用户级设置会覆盖其显隐性的问题
                            let currentVisible = {};
                            const currentMetaItem = currentMetaItemsMap[attrcode] || {};
                            const initUserMetaItem = initUserMetaItemObj[attrcode] || {};
                            // 原始模板项和页面模板项  如果两者不一样  说明是领域对模板的做了修改
                            // 未操作的用户级模板隐藏而页面却显示 未操作的用户级模板显示而页面却隐藏
                            let currentMetaItemVisible = currentMetaItem.visible;
                            if (currentMetaStore) {
                                // 真实显隐性
                                currentMetaItemVisible = getMetaStoreItemVisible(currentMetaStore, moduletype, attrcode);
                            }
                            if ((!initUserMetaItem.visible && currentMetaItemVisible) || (initUserMetaItem.visible && !currentMetaItemVisible)) {
                                currentVisible = { visible: initUserMetaItem.visible };
                            }

                            // 用于更新当前页面
                            return { ...currentMetaItem, ...result, ...currentVisible };
                        });

                        // 保存用数据
                        data[areaCode] = {
                            areaId: areaCode,
                            visible: areaVisible,
                            items: saveItems,
                            area_type: moduletype === 'form' ? '1' : (moduletype === 'table' ? '2' : '1'),
                        };

                        // 把用户自定义的项插入到设置数据里 需要定位位置
                        customItems.forEach(ele => {
                            let { attrcode, index, item } = ele;
                            metaItems.splice(index, 0, item);
                        });

                        // 更新用
                        currentMeta[areaCode].items = metaItems;
                    }

                } else {
                    console.log('未找到原始的模板');
                }
            });
            // 核心数据 信息组  formInfoGroupRelation, coreDataItems
            if (nextMeta?.coreDataItems?.length) {
                currentMeta['coreDataItems'] = nextMeta.coreDataItems;
            }
            if (nextMeta?.formInfoGroupRelation?.length) {
                currentMeta['formInfoGroupRelation'] = nextMeta.formInfoGroupRelation;
                data['formgroup'] = (nextMeta.formInfoGroupRelation || []).map(item => {

                    return {
                        ...item,
                        items: JSON.stringify(item.items || []),
                    };
                });
            }

            // 关键信息区
            if (nextMeta?.layout?.length) {
                currentMeta['layout'] = nextMeta.layout;
                data['layout'] = nextMeta.layout;

                const layoutMeta = nextMeta.layoutMeta;
                layoutMeta && Object.keys(layoutMeta).forEach(key => {
                    currentMeta[key].areaVisible = layoutMeta[key].visible;
                    data[key] = layoutMeta[key];
                });
            }

            setColumns(currentMeta, data).then(res => {
                if (res.success) {
                    const langJson = currentStore.getStore('langJson');
                    toast({ content: langJson['save-success'] /*字段设置保存成功*/, light: true });
                    currentStore.setConfig({ visible: false }, true);
                    delete currentMeta['originlayout'];
                    delete currentMeta['flatLayout'];
                    // 强制更新属性，以用户级的显隐性为准
                    // Object.keys(currentMeta).forEach(moduleId => {
                    //     const { items, moduletype } = currentMeta[moduleId] || {};
                    //     if (items && items.length) {
                    //         const currentItemVisible = items.reduce((prevValue, currentItem) => {
                    //             const { attrcode, visible } = currentItem;
                    //             prevValue[attrcode] = visible;
                    //             return prevValue;
                    //         }, {});

                    //         switch (moduletype) {
                    //             case 'form':
                    //                 // 需要注意下，表单分组，多页签等情况
                    //                 let DataSource = this['formDataSource'] || {},
                    //                     currentSource = {};
                    //                 // 用于更新meta
                    //                 let id = moduleId;
                    //                 // 当前store是否存在 是否为主表ID 
                    //                 if (DataSource[moduleId]) {
                    //                     currentSource = DataSource[moduleId];
                    //                 } else {
                    //                     // 不存在时 判断是否为子表ID, 找到子表ID对应的主表ID;
                    //                     let formrelation = (currentMeta && currentMeta.formrelation) || {};
                    //                     Object.keys(formrelation).forEach(item => {
                    //                         if (Array.isArray(formrelation[item]) && formrelation[item].includes(moduleId) && DataSource[item]) {
                    //                             currentSource = DataSource[item];
                    //                             id = item;
                    //                         } else {
                    //                             // 暂时先移除 页签字段 todo
                    //                             // 多页签数据处理 假如不是子表时  需进行判断是否为多页签子表 
                    //                             let formassociatedrelation = (currentMeta && currentMeta.formassociatedrelation) || {};
                    //                             Object.keys(formassociatedrelation).forEach(tabsID => {
                    //                                 if (Array.isArray(formassociatedrelation[tabsID].formtabs) && formassociatedrelation[tabsID].formtabs.includes(item)) {
                    //                                     currentSource = DataSource[tabsID];
                    //                                     id = tabsID;
                    //                                 }
                    //                             });
                    //                         }
                    //                     });
                    //                 }
                    //                 // 初始化之后才进行 根据store 取值 为初始化  还是根据meta 自身状态
                    //                 if (currentSource && typeof currentSource.setItemAttribute == 'function') {
                    //                     currentSource.setItemAttribute('visible', currentItemVisible, true, false);
                    //                 } else {
                    //                     // 没有找到form的store , 可以考虑创建一个， 要考虑子表 多页签等情况
                    //                     // this['formDataSource'][id] = this['formDataSource'][id] || this.form._store();
                    //                 }
                    //                 break;
                    //             case 'table':
                    //                 {
                    //                     const currentSource = this.tableDataSource[moduleId] || this.editTableDataSource[moduleId] || this.cardTableDataSource[moduleId];
                    //                     if (currentSource) {
                    //                         const colKeys = Object.keys(currentItemVisible);
                    //                         colKeys.forEach(key => {
                    //                             currentSource.setColumnProps(colKeys, { visible: currentItemVisible[key] }, { shouldUpdate: false });
                    //                         });
                    //                     } else {
                    //                         // 多页签，共享页签，侧拉，展开表  通过setMeta来更新
                    //                         // 共享页签，侧拉，展开表，多页签
                    //                         // 扫描所有的卡片表格 store，做一次更新
                    //                         // Object.keys(this.cardTableDataSource).forEach(key => {
                    //                         //     const currentSource = this.cardTableDataSource[key];
                    //                         //     currentSource.setColumnProps(currentMeta, moduleId, false, this.app_context);
                    //                         // });
                    //                     }
                    //                 }
                    //                 break;
                    //             default:
                    //                 console.warn('未找到对应渲染的区域');
                    //                 break;
                    //         }

                    //     }
                    // });

                    // 然后整体组件更新
                    pageScope.meta.setMeta(currentMeta);
                }
            }).catch(err => {
                currentStore.setConfig({ visible: false }, true);
                delete currentMeta['originlayout'];
                delete currentMeta['flatLayout'];
                pageScope.meta.setMeta(currentMeta);
            });

            onSave && onSave();
        }}
        onReset={() => {
            const pageMeta = pageScope.meta.getMeta();

            resetColumns(pageMeta).then(res => {
                if (res.success) {
                    currentStore.initCache(false, () => {
                        let nextMeta = currentStore.getTransformCache();

                        Object.keys(nextMeta).forEach(areaCode => {
                            const areaMeta = pageMeta[areaCode];
                            if (areaMeta) {
                                const { moduletype } = areaMeta;
                                // 当前页面数据
                                const currentMetaItems = areaMeta.items;
                                // 设置数据
                                const nextMetaItems = nextMeta[areaCode]?.items;
                                // 设置显示态数据
                                const nextMetaItemsMap = nextMeta[areaCode]?.itemsMap || {};
                                // 原始数据里不展示的项
                                const rawHiddenItemOnj = nextMeta[areaCode]?.rawHiddenItemOnj || {};
                                // 未操作的用户级模板
                                const initUserMetaItemObj = nextMeta[areaCode]?.initUserMetaItemObj || {};
                                // store
                                const currentMetaStore = getMetaStore(pageScope, pageMeta, moduletype, areaCode);

                                if (currentMetaItems && nextMetaItems) {
                                    // 领域添加的项
                                    const customItems = [];

                                    // 找到自定义数据
                                    const currentMetaItemsMap = {};
                                    currentMetaItems.forEach((item, index) => {
                                        const { attrcode } = item;
                                        currentMetaItemsMap[attrcode] = item;
                                        if (!nextMetaItemsMap[attrcode]) {
                                            customItems.push({
                                                attrcode,
                                                index,
                                                item,
                                            });
                                        }
                                    });

                                    // 合并数据
                                    const metaItems = nextMetaItems.map(item => {
                                        const { attrcode } = item;
                                        const { visible, islock, ishighlight, isbold, iscoredata } = nextMetaItemsMap[attrcode] || {};

                                        const result = {};
                                        visible !== undefined && (result.visible = visible);
                                        islock !== undefined && (result.islock = islock);
                                        islock !== undefined && (result.resizable = !islock);
                                        // ishighlight !== undefined && (result.ishighlight = ishighlight);
                                        isbold !== undefined && (result.isbold = isbold);
                                        iscoredata !== undefined && (result.iscoredata = iscoredata);

                                        // 解决业务设置了显隐性后用户级设置会覆盖其显隐性的问题
                                        let currentVisible = {};
                                        const currentMetaItem = currentMetaItemsMap[attrcode] || {};
                                        const initUserMetaItem = initUserMetaItemObj[attrcode] || {};
                                        // 原始模板项和页面模板项  如果两者不一样  说明是领域对模板的做了修改
                                        // 未操作的用户级模板隐藏而页面却显示 未操作的用户级模板显示而页面却隐藏
                                        let currentMetaItemVisible = currentMetaItem.visible;
                                        if (currentMetaStore) {
                                            // 真实显隐性
                                            currentMetaItemVisible = getMetaStoreItemVisible(currentMetaStore, moduletype, attrcode);
                                        }
                                        if ((!initUserMetaItem.visible && currentMetaItemVisible) || (initUserMetaItem.visible && !currentMetaItemVisible)) {
                                            currentVisible = { visible: initUserMetaItem.visible };
                                        }

                                        // 用于更新当前页面
                                        return { ...currentMetaItem, ...result, ...currentVisible };
                                    });

                                    // 把用户自定义的项插入到设置数据里 需要定位位置
                                    customItems.forEach(ele => {
                                        let { attrcode, index, item } = ele;
                                        metaItems.splice(index, 0, item);
                                    });

                                    // 更新用
                                    pageMeta[areaCode].items = metaItems;
                                }

                            } else {
                                console.log('未找到原始的模板');
                            }
                        });
                        // 核心数据 信息组  formInfoGroupRelation, coreDataItems
                        if (nextMeta?.coreDataItems?.length) {
                            pageMeta['coreDataItems'] = nextMeta.coreDataItems;
                        }
                        if (nextMeta?.formInfoGroupRelation?.length) {
                            pageMeta['formInfoGroupRelation'] = nextMeta.formInfoGroupRelation;
                        }

                        // 关键信息区
                        if (nextMeta?.layout?.length) {
                            pageMeta['layout'] = nextMeta.layout;
                        }
                        delete pageMeta['originlayout'];
                        delete pageMeta['flatLayout'];
                        pageScope.meta.setMeta(pageMeta);
                    });

                    const langJson = currentStore.getStore('langJson');
                    toast({ content: langJson['reset-success'] /*字段设置重置成功*/, light: true });

                    // 关闭弹窗
                    currentStore.setConfig({ visible: false }, true);
                }
            }).catch(err => {
                currentStore.setConfig({ visible: false }, true);
                delete pageMeta['originlayout'];
                delete pageMeta['flatLayout'];
                pageScope.meta.setMeta(pageMeta);
            });

            onReset && onReset();
        }}
        onHide={() => {
            currentStore.setConfig({ visible: false }, true);
            onHide && onHide();
        }}
        store={currentStore}
    />;
}

/**
 * 显示
 * @memberof MetaFieldSetting
 * @param {object} config 
 * @param {*} shouldForceUpdate 
 */
function open(config = {}, shouldForceUpdate = true) {
    const id = config.id || uniqueId;

    let currentStore = getStore.call(this, id);

    // 多语数组
    const { languageMeta = [] } = this?.meta?.getMeta() || {};
    languageMeta.length && currentStore.setStore(['languageMeta'], languageMeta, false);

    currentStore.setConfig({ visible: true, ...config }, false);
    currentStore.initCache(shouldForceUpdate);
}

/**
 * 所有的外部api
 */
const API = {
    init,
    createMetaFieldSetting,
    open,
};

export default function compatible() {
    this.register("metaFieldSetting");
    return {
        store: MetaFieldSetting.useMetaFieldSetting,
        ...apiBindPage.call(this, API),
    };
}

function apiBindPage(API) {
    let res = {};
    for (let pop of Object.keys(API)) {
        res[pop] = API[pop].bind(this);
    }
    return res;
}

compatible.init = init;
compatible.component = MetaFieldSetting;
compatible.displayName = "MetaFieldSetting";
compatible.unfinished = [];